import React from "react";
import { PortableText } from "@portabletext/react";

// Link inherits font from its parent <p> (matches the original DOM where
// anchors had no explicit font-family). Green keeps an explicit font class
// because PortableText's <span> can otherwise lose the parent's font through
// Tailwind preflight / other resets.
const makeMarks = (fontClass) => ({
  link: ({ value, children }) => (
    <a
      href={value?.href}
      target={value?.openInNewTab ? "_blank" : undefined}
      rel={value?.openInNewTab ? "noopener noreferrer" : undefined}
      style={{ color: "#45818e" }}
    >
      {children}
    </a>
  ),
  green: ({ children }) => (
    <span className={fontClass} style={{ color: "#274e13" }}>
      {children}
    </span>
  ),
});

const enComponents = {
  block: {
    normal: ({ children }) => <p className="font-amaticsc-bold">{children}</p>,
  },
  marks: makeMarks("font-amaticsc-bold"),
};

const jpComponents = {
  block: {
    normal: ({ children }) => <p className="font-zenkurenaido">{children}</p>,
  },
  marks: makeMarks("font-zenkurenaido"),
};

const GlanceItem = ({ item }) => {
  return (
    <div className="glance-item-section">
      <div className="glance-title font-amaticsc-bold">
        <PortableText value={item?.en} components={enComponents} />
      </div>
      <div className="glance-sub-title font-zenkurenaido">
        <PortableText value={item?.jp} components={jpComponents} />
      </div>
    </div>
  );
};

export default GlanceItem;
